import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs"

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import log1 from "../../assets/Images/Logo/1.png";
import log2 from "../../assets/Images/Logo/1.5.jpg";
import log3 from "../../assets/Images/Logo/2.png";
import log31 from "../../assets/Images/Logo/2.5.png";
import log4 from "../../assets/Images/Logo/3.png";
import log5 from "../../assets/Images/Logo/4.png";
import log6 from "../../assets/Images/Logo/5.png";
import log7 from "../../assets/Images/Logo/6.png";
import log8 from "../../assets/Images/Logo/7.png";

import sbp1 from "../../assets/Images/studiobrand/bag.GIF";
import sbp2 from "../../assets/Images/studiobrand/hoodie.GIF";
import sbp3 from "../../assets/Images/studiobrand/can.png";
import sbp4 from "../../assets/Images/studiobrand/mug.png";

import pos1 from "../../assets/Images/posters/catposter.png";
import pos2 from "../../assets/Images/posters/postervp.png";
import pos3 from "../../assets/Images/posters/3dposter.png";
import pos4 from "../../assets/Images/posters/3D-poster-final.png";


import d31 from "../../assets/Images/3dpot/3dcat.jpg";
import d32 from "../../assets/Images/3dpot/3d1.jpg";
import d33 from "../../assets/Images/3dpot/3d2.jpg";
import d34 from "../../assets/Images/3dpot/3d3.jpg";
import d35 from "../../assets/Images/3dpot/3d4.jpg";
import d36 from "../../assets/Images/3dpot/3d5.JPG";


import d31m from "../../assets/Images/3dpot/3d11.mp4";
import d31m2 from "../../assets/Images/3dpot/3d22.mp4";
import d31m3 from "../../assets/Images/3dpot/3d33.mp4";


import fac2 from "../../assets/Images/progress/3d1.png";
import fac1 from "../../assets/Images/progress/3d.png";
import fac4 from "../../assets/Images/progress/3d1.mp4";
import fac3 from "../../assets/Images/progress/3d5.png";
import fac5 from "../../assets/Images/progress/vanhome.png";


import mas1 from "../../assets/Images/progress/1.jpg";
import mas2 from "../../assets/Images/progress/0.jpg";
import mas3 from "../../assets/Images/progress/concept2.jpg";
import mas4 from "../../assets/Images/progress/concept3.jpg";
import mas5 from "../../assets/Images/progress/catprog1.png";
import mas6 from "../../assets/Images/progress/catprog2.png";
import mas7 from "../../assets/Images/progress/2.jpg";
import mas8 from "../../assets/Images/progress/4.png";
import mas9 from "../../assets/Images/fieldpics/field3.JPG";
import mas10 from "../../assets/Images/progress/10.jpg";






































import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";


import Slideshow from "../../assets/Slideshow/Slideshow"; 


const Lo1Product = () => {
    const navigate = useNavigate();

    const images = [lowprot1, lowprot2, figma];
    const images1 = [log1,log2,log3,log31,log4,log5,log6,log7,log8]
    const images2 = [sbp1,sbp2,sbp3,sbp4]
    const images3 = [pos1,pos2,pos3,pos4]
    const images4 = [d31,d32,d33,d34,d35,d36,d31m,d31m2,d31m3]
    const images5 = [fac5,fac1,fac2,fac3,fac4]
    const images6 = [mas10,mas1,mas2,mas3,mas4,mas5,mas6,mas7,mas8,mas9]


    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo1-headings">
                <h1>Interactive Product</h1>
                <p>Products that I have made</p>

                
            </div>

            <div className="line"></div>

            <div style={{ padding: '0.1rem 7.5rem' }}>
                            <BreadcrumbHeader />
            </div>

            <div className="content-lo1">
                <div className="content-lo1-product">
                    <div className="content-lo1-product-text">
                        <h1>Group Logo and artworks</h1>
                        <p>
                            Our studio started with a simple logo sketch a concept that needed to be refined and shaped. After our team voted
                            on a final version, I started with digitalizing it. Using Adobe Illustrator, I updated the logo with clean lines,
                            and vectors. This wasn't just a technical procedure; we wanted to make sure the logo fit our group's identity.
                            
                        </p>
                        <p>

                        </p>
                        
                    </div>

                    <div className="content-lo1-product-text2">
                        <h1>Studio Brand Products</h1>
                        <p>
                            Once we were done with the logo, I took the initiative to create and imagine how our studio/ brand would look on the
                            real life products, this lead me to creating the hoodie, bags, mugs, and other items. This was my way to explore our
                            brand identity and testing how our brand would leave an impression on the physical format.
                        </p>
                        
                    </div>

                    <div className="content-lo1-product-text3">
                        <h1>Posters</h1>
                        <p>
                            I made a few poster for the clients, by combining cat memes to align with our campaign, this was my first time making
                            a product with an elements that is humorous (cat memes), but I did also learn that this humour creates engagement.
                        </p>
                        <p>
                            You can check the final product for the poster on the very last picture of the slideshow, where I added Lumi our cat mascot
                            to the poster.
                        </p>
                        
                    </div>

                    <div className="content-lo1-product-text4">
                        <h1>3D Poster with arduino</h1>
                        <p>
                            For this one Adib and I attempted to create a 3D Poster with Arduino to create more interaction and engagement from our target audience,
                            we wanted to break a bounderies of what a poster could be, turning a flat 2D poster to a 3D poster where it makes people react and engage.
                        </p>
                        <p>
                            I also took participate in the last display event where our product is showcased, even though the cat mascot wasn't fully finished, I still manage
                            to show what this 3D poster could do in this marketing campaign. For the picture you can check how the 3D poster look like at the very last picture
                            of the slideshow.
                        </p>
                        
                    </div>

                    {/* <div className="content-lo1-product-text5">
                        <h1>This Website</h1>
                        <p>
                            Of course, the project would not be complete without the portfolio website. I developed and built it not only to keep track of my work,
                            but also as a product an interactive representation of everything I've done.
                        </p>
                        
                        
                    </div> */}

                    <div className="content-lo1-product-text6">
                        <h1>3D Model For the Homepage</h1>
                        <h2>What's done</h2>
                        <p>
                            I've managed to import the 3D face model on blender sculpting and also using decimate to manage its resources so it can load on my portfolio without making my website lags.
                            This add a unique, visual element that gives my portfolio a creative and personal touch. The model is already rendered using React Three Fiber, making it feel more dynamic compared 
                            to a static landing page.
                        </p>
                        <h2>What's next</h2>
                        <p>
                            The next step is to make the eyes follow the user's cursor, adding a playful and interactive element that reacts to movement. This feature is still on progress, and I plan to complete it to enhance the feeling
                            of responsiveness and engagement for the viewer.
                        </p>
                        <h2>Why it matters</h2>
                        <p>
                            Even though the interaction isn't finished yet, the model already shows my willingness to go beyond standard design. It reflects my interest in combining 3D, web development, and user experience to build products that stand out and feel more alive.
                        </p>

                        
                        
                    </div>

                    <div className="content-lo1-product-text7">
                        <h1>Mascot for Marketing Campaign</h1>
                        <h2>Turning an idea into a Physical Mascot</h2>
                        <p>
                            To give our Virtual Production campaign a more personal and professional touch, I created a 3D mascot cat named Lumi, I named this cat after our studio brand name Octolume, and was based on my teamate sketch.
                            Using Blender, I modeled the character with help from my teacher Chris, who taught me how to use proper image references and refine a low-poly design.

                        </p>
                        <h2>Making the Campaign Truly Ours</h2>
                        <p>
                            Initially, our 3D poster used a generic model. Lumi was created to replace this placeholder, giving our campaign an original, branded figure that match our identity and cat meme theme.
                        </p>
                        <h2>Strenghtening the Physical Experience</h2>
                        <p>
                            Although the mascot wasn't fully finished by the final event, Ishowcased how it would enhance the interactive poster with Arduino, Lumi's presence added a playful,
                            memorable element that reasonated with students and tied the entire campaign together.
                        </p>

                        
                        
                    </div>

                    <div className="content-lo1-product-slideshow">
                        <Slideshow images={images1} />

                    </div>


                    <div className="content-lo1-product-slideshow2">
                        <Slideshow images={images2} />

                    </div>

                    <div className="content-lo1-product-slideshow3">
                        <Slideshow images={images3} />

                    </div>

                    <div className="content-lo1-product-slideshow4">
                        <Slideshow images={images4} />

                    </div>

                    <div className="content-lo1-product-slideshow5">
                        <Slideshow images={images5} />

                    </div>

                    <div className="content-lo1-product-slideshow6">
                        <Slideshow images={images6} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo1Product;